import { render } from "./CarteleraPage.vue?vue&type=template&id=94ddb90e&scoped=true"
import script from "./CarteleraPage.vue?vue&type=script&lang=js"
export * from "./CarteleraPage.vue?vue&type=script&lang=js"

import "./CarteleraPage.vue?vue&type=style&index=0&id=94ddb90e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94ddb90e"]])

export default __exports__